import classNames from 'classnames';
import { Button, ButtonType } from '@nx-frontend/shared/ui/button';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';
import { getTextClassNames } from '@nx-frontend/shared/themes';
import { PortalStyleConfig, PortalTextType, ThemeColorSchemas } from '@nx-frontend/shared/types';
import { useStartFilesUpload } from '../hooks/useStartFilesUpload';

export interface FileManagerHeaderProps {
  themeColors: ThemeColorSchemas;
  themeStyle: PortalStyleConfig;
  title: string;
  orgRole: string;
  isUploadBtnVisible?: boolean;
  context: {
    sessionId: string | null;
    portalId: string;
    workspaceId: string;
  };
}

export function FilesManagerHeader({
  themeColors,
  themeStyle,
  title,
  context,
  orgRole,
  isUploadBtnVisible,
}: FileManagerHeaderProps) {
  const startFilesUpload = useStartFilesUpload();
  const { sessionId, portalId, workspaceId } = context;

  const handleStartFilesSelect = () => {
    if (sessionId) {
      startFilesUpload({ sessionId, portalId, workspaceId });
    }
  };

  const showUploadButton = orgRole !== 'visitor' && isUploadBtnVisible;

  return (
    <div>
      <div className="flex items-center mb-3">
        <div className={classNames('flex items-center', ...getTextClassNames(themeColors, PortalTextType.SURFACE))}>
          <div>
            <div className="w-4 h-4 mr-1">
              <Icon icon={IconsMap.PAPERCLIP} />
            </div>
          </div>
          <span>{title}</span>
        </div>

        {showUploadButton && (
          <div className="ml-auto">
            <Button
              type={ButtonType.PRIMARY}
              themeColors={themeColors}
              themeStyle={themeStyle}
              onClick={handleStartFilesSelect}
            >
              <Icon icon={IconsMap.UPLOAD} className="w-4 h-4 mr-2" />
              <span>Upload files</span>
            </Button>
          </div>
        )}
      </div>
      {/*<FileManagerFilters />*/}
    </div>
  );
}

export default FilesManagerHeader;
